/** Bounded public copy for geography coverage backed by PUBLIC_COVERAGE_COUNTS.json. */

export const PUBLIC_COVERAGE_HEADLINE =
  'California cities and counties covered by ClimatePlans';

export const PUBLIC_COVERAGE_DETAIL =
  'Explore communities in the ClimatePlans coverage set; indicator and inventory availability varies by location and dataset.';

export const HERO_COVERAGE_QUALIFIER =
  'Data availability varies by community, indicator, and dataset.';

export const HERO_COVERAGE_RELEASE_NOTE =
  'Coverage based on the current reviewed ClimatePlans data release.';

export type HeroStatCard = {
  mainText: string;
  label: string;
};

/** Must stay aligned with operations/.../CP-WP-006/PUBLIC_COVERAGE_COUNTS.json homepage_constants. */
export const HERO_STAT_CARDS: readonly HeroStatCard[] = [
  { mainText: '459', label: 'CITIES' },
  { mainText: '58', label: 'COUNTIES' },
  { mainText: '518', label: 'COMMUNITIES' },
  { mainText: '100+', label: 'INDICATORS' },
] as const;
